import { API_BASE_URLS } from "../config/api.config";

const BASE_PATH = "/Lookup";

const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.backend || "";
  return baseUrl.replace(/\/$/, "");
};

const buildLookupUrl = (path = "") => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};

export const LOOKUP_ENDPOINTS = {
  GET_REGIONS: buildLookupUrl("/getregions"),
  GET_APPLICATION_USED_HOURS_REASON_DATA: buildLookupUrl(
    "/getApplicationUsedHoursReasonData",
  ),
  GET_SUP_REG_COUNTRY_OFFICE_DATA_BY_REGION: buildLookupUrl(
    "/getSupRegCountryOfficeDataByRegion",
  ),
  GET_SUPER_REGIONS_BY_REGION: (regionId) =>
    buildLookupUrl(`/getsuperregions/${regionId}`),
  GET_ROLES: (regionId) => buildLookupUrl(`/getroles/${regionId}`),
  GET_STATUSES: buildLookupUrl("/statuses"),
  GET_COUNTRIES_BY_SUPER_REGION: (superRegionId) =>
    buildLookupUrl(`/countries/${superRegionId}`),
  GET_SAVING_REASONS: (applicationUsedId) =>
    buildLookupUrl(`/getsavingreason/${applicationUsedId}`),
};

export default LOOKUP_ENDPOINTS;
